import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/home";
import AktualnoscApp from "./pages/atualnosci"; 
import Rozszerzenie from "./pages/aktualnosc"; // Corrected import
import Matecznik from "./pages/matecznik";
import Spektakl from "./pages/spektakl";
import spetakleData from "./components/spetakleData";
import { SPEKTAKLE_GALERIE } from "./pages/spektakleGalerie";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aktualnosci" element={<AktualnoscApp />} />
          <Route path="/rozszeszenie/:id" element={<Rozszerzenie />} /> {/* Added :id */}
          <Route path="/spektakle/matecznik" element={<Matecznik />} />
          <Route path="/spektakle/piesni-rzeki" element={<Spektakl title="Pieśni Rzeki" content={spetakleData[1].content} heroImage={spetakleData[1].image} gallery={SPEKTAKLE_GALERIE.rzeki} />} />
          <Route path="/spektakle/dla-mnie-bomba" element={<Spektakl title="Dla mnie Bomba!!!" content={spetakleData[2].content} heroImage={spetakleData[2].image} gallery={SPEKTAKLE_GALERIE.bomba} />} />
          <Route path="/spektakle/dom-posterunkowa-1" element={<Spektakl title="Dom Posterunkowa 1 Supraśl" content={spetakleData[3].content} heroImage={spetakleData[3].image} gallery={SPEKTAKLE_GALERIE.dom} />} />
          <Route path="/spektakle/pan-maluskiewicz" element={<Spektakl title="Pan Maluśkiewicz" content={spetakleData[4].content} heroImage={spetakleData[4].image} gallery={SPEKTAKLE_GALERIE.maluskiewicz} />} />
          <Route path="/spektakle/nosferatu" element={<Spektakl title="NOSFERATU – DZIENNIK ZARAZY" content={spetakleData[5].content} heroImage={spetakleData[5].image} gallery={SPEKTAKLE_GALERIE.nosferatu} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
